export default __webpack_public_path__ + "static/media/GRAB.30dbcc90.svg";